<!-- 论文成绩查询 -->
<template>
    <div class="el-PaperScoreQuery">
        <el-row class="page_content">
            <h1 class="head_title">论文成绩查询</h1>
            <el-table
                :data="tableData"
                border
                style="width: 100%;">
                <el-table-column
                    prop="title"
                    header-align="center"
                    align="center"
                    label="论文名称">
                </el-table-column>
                <el-table-column
                    prop="title"
                    header-align="center"
                    align="center"
                    label="学期">
                </el-table-column>
                <el-table-column
                    prop="title"
                    header-align="center"
                    align="center"
                    label="总评">
                </el-table-column>
            </el-table>
        </el-row>
    </div>
</template>
<script>
export default {
  name: "PaperScoreQuery",
  data() {
    return {
        tableData: [],
    };
  },
  created() {
   
  },
  methods: {
    
  }
};
</script>
<style  lang="less">
  @import '../../styles/base.less';
  .el-PaperScoreQuery{
    .wd{
        color: @red;
    }
    // .el-dialog__body{
    //     border-top:1px solid #ebeef5;
    // }
  }
</style>


// WEBPACK FOOTER //
// src/pages/dissertation/PaperScoreQuery.vue